<script>
  import { ShopboxGoLiveApp } from "@shopboxai/sb-go-live-app";
  import { currentUser } from "../stores";
  import { useNavigate } from "svelte-navigator";

  const navigate = useNavigate();
</script>

<ShopboxGoLiveApp user={$currentUser} on:redirect={(e) => navigate(e.detail)} />
